import { useEffect, useState } from 'react';
import { extractSubdomainFromUrl } from '../lib/subdomain';
import { tenantApi } from '../lib/tenant-api';

export function useTenantBrandingFromUrl() {
  const [subdomainFromUrl, setSubdomainFromUrl] = useState<string | null>(null);
  const [tenantName, setTenantName] = useState<string | null>(null);
  const [canonicalSubdomain, setCanonicalSubdomain] = useState<string | null>(null);
  const [isResolved, setIsResolved] = useState(false);

  useEffect(() => {
    const subdomain = extractSubdomainFromUrl();
    if (!subdomain) {
      setIsResolved(true);
      return;
    }

    setSubdomainFromUrl(subdomain);

    tenantApi
      .getTenantBranding(subdomain)
      .then((branding) => {
        setTenantName(branding.name);
        setCanonicalSubdomain(branding.subdomain);
      })
      .catch(() => {
        setTenantName(subdomain);
        setCanonicalSubdomain(subdomain);
      })
      .finally(() => {
        setIsResolved(true);
      });
  }, []);

  return {
    hasSubdomain: subdomainFromUrl !== null,
    isResolved,
    tenantName: isResolved ? tenantName : null,
    canonicalSubdomain,
  };
}
